export const DEFAULT = "0"
export const DIRECT_AUTH_URL = "1"